import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Company, ConnectionService } from '../../services/Connection/connection.service';
import { CacheService } from '../../services/Cache/cache.service';
import { CartService } from '../../services/Cart/cart.service';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';

@Component({
  selector: 'app-top-menu-two',
  templateUrl: './top-menu-two.component.html',
  styleUrls: ['./top-menu-two.component.css']
})
export class TopMenuTwoComponent {
  @ViewChild('buttonSearch') buttonSeach!: ElementRef;
  @ViewChild('divInput', {static: false}) divInput!: ElementRef;
  @ViewChild('input') input!: ElementRef;
  @ViewChild('imgCompany') imgCompany!: ElementRef;
  @ViewChild('divIcon') divIcon!: ElementRef;
  @ViewChild('inputDesktop') inputDesktop!: ElementRef;
  @ViewChild('divBar') divBar!: ElementRef;
  @ViewChild('topMenu') topMenu!: ElementRef;

  //#region Variaveis locais
    private typeParam!: typeInterface;
    readOnlyState: boolean = false;
    nameCompany: string = '';
    scrollTopPosition: number = 0;
    img!: string;
    company!: Company
    nameEmpresa: string = "";
    verificationTable!: boolean;
    counterCart: number = 0;
    userConfirmation = false
    user!: Cliente;
  //#endregion

  //#region Inicializadores

    constructor(
      private connection: ConnectionService,
      private cartService: CartService,
      private router: Router
    ){
      this.cartService.counter$.subscribe(newCount => {
        this.counterCart = newCount;
      });

      this.connection.company$.subscribe(newCompany => {
        if(newCompany){
          this.company = newCompany
          this.img = newCompany.company.logo;
        }
      })

      this.connection.nameCompany$.subscribe(newNameCompany => {
        this.nameCompany = newNameCompany
      })

      this.connection.typeParam$.subscribe((newTypeParam) => {
        if(newTypeParam){
          //Verifica o tipo do parametro
          this.typeParam = newTypeParam;
          if(this.typeParam.type == 1 || this.typeParam.type == 2){
            this.verificationTable = true
          }
          else{
            this.verificationTable = false
          }
        }

      })

      this.connection.user$.subscribe((data) =>{
        this.user = data;
        if(this.user){
          this.userConfirmation = true;
        }
      })

      this.connection.readOnlyState$.subscribe((data) =>{
        this.readOnlyState = data;
      })

    }

    //Chama as funções assim que o component é inicializado
    ngOnInit(): void {
    }

    //Chama as funções assim que todo o DOM da aplicação foi carregado
    ngAfterViewInit(){
      this.cartService.getCartItems()
    }

    //Navegação para a página inicial
    navegationMenu(){
      if(this.typeParam.type == 0){

        this.router.navigate([this.nameCompany]);

      }
      else if(this.typeParam.type == 3){

        this.router.navigate([this.nameCompany, 'B']);

      }

    }
}
